import namespace from '@/context/namespace';

const tdk = {
  [namespace.home]: {
    title: 'DJI大疆社区 - 大疆用户官方交流平台',
    description: 'DJI大疆社区是深圳大疆创新打造的用于用户之间技术交流、生活分享和航拍作品、航拍无人机教程讨论的平台。大疆社区立志于汇集民智的力量,让用户和我们一起创造完美的无人机飞行影像产品与卓越的用户体验。',
    keywords: '大疆社区,无人机玩家交流,手持设备玩家交流,无人机玩法,无人机教程,DJI,DJI Mavic,DJI Mini,DJI Air,Osmo Action,Osmo Pocket,DJI Avata,DJI Neo,DJI Flip',
    canonicalLink: 'https://bbs.dji.com/',
  },
  [namespace.square]: {
    title: '广场 - 大疆社区',
    description: '社区广场，DJI大疆用户交流聚集地，所有的社区内容都可以在这里找到',
    keywords: '大疆社区,无人机玩家交流,手持设备玩家交流,无人机玩法,无人机教程,DJI,DJI Mavic,DJI Mini,DJI Air,Osmo Action,Osmo Pocket,DJI Avata,DJI Neo,DJI Flip',
    canonicalLink: 'https://bbs.dji.com/pro/square',
  },
  [namespace.consult]: {
    title: '咨询 - 大疆社区',
    description: '社区咨询，任何玩机及使用问题，可在此咨询，官方客服即时回复，售后无忧',
    keywords: '大疆社区，售后咨询，玩机问题交流，经验分享',
    canonicalLink: 'https://bbs.dji.com/pro/consult',
  },
  [namespace.activity]: {
    title: '活动 - 大疆社区',
    description: '社区活动，官方活动发布区，为大疆用户提供更丰富的社区体验及活动内容',
    keywords: '大疆社区,无人机玩家交流,手持设备玩家交流,无人机玩法,无人机教程,DJI,DJI Mavic,DJI Mini,DJI Air,Osmo Action,Osmo Pocket,DJI Avata,DJI Neo,DJI Flip',
    canonicalLink: 'https://bbs.dji.com/pro/activity',
  },
  [namespace.group]: {
    title: '圈子 - 大疆社区',
    description: '社区圈子，为不同设备和兴趣的用户提供专属沟通交流空间',
    keywords: '大疆社区,无人机玩家交流,手持设备玩家交流,无人机玩法,无人机教程,DJI,DJI Mavic,DJI Mini,DJI Air,Osmo Action,Osmo Pocket,DJI Avata,DJI Neo,DJI Flip',
    canonicalLink: 'https://bbs.dji.com/pro/group',
  },
  [namespace.profile]: {
    title: '个人资料页 - 大疆社区',
    keywords: '修改用户名头像',
  },
  [namespace.search]: {
    title: '搜索 - 大疆社区',
    description: '社区搜索，在这里寻找你想要的答案',
    keywords: '大疆社区,无人机玩家交流,手持设备玩家交流,无人机玩法,无人机教程,DJI,DJI Mavic,DJI Mini,DJI Air,Osmo Action,Osmo Pocket,DJI Avata,DJI Neo,DJI Flip',
    canonicalLink: 'https://bbs.dji.com/pro/search',
  },
};

export default tdk;
